import React from 'react'
import {
  OrderDetailsBlueButton,
  OrderDetailsGrayButton,
} from './style/button.css'

export const returnType = {
  default: 'default',
  lifetime: 'lifetime',
}

export const lifetimeButton = {
  claim: {
    label: 'Lifetime Replacement Claimed',
    Button: OrderDetailsGrayButton,
    disabled: true,
    withChat: false,
  },
  selectItem: {
    label: 'Select Item',
    Button: OrderDetailsBlueButton,
    disabled: false,
    withChat: false,
  },
  selectItemDisabled: {
    label: 'Select Item',
    Button: OrderDetailsGrayButton,
    disabled: true,
    withChat: false,
  },
  ineligible: {
    label: 'Lifetime Replacement Ineligible',
    Button: OrderDetailsGrayButton,
    disabled: true,
    withChat: true,
  },
  empty: {
    label: '',
    Button: function Button() { return <></> },
    disabled: true,
  },
}
